var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyTaksEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166,
    height: 203,
    viewBox: "0 0 166 203"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "MYTaksEmptyState_svg__a",
    width: "229.2%",
    height: "193.3%",
    x: "-64.6%",
    y: "-32.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 19,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.226735433 0 0 0 0 0.437054197 0 0 0 0 0.687818878 0 0 0 0.189056839 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "MYTaksEmptyState_svg__b",
    width: 95.939,
    height: 132.893,
    x: 0,
    y: 7.107,
    rx: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 9h160v160H3z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 9)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#MYTaksEmptyState_svg__a)",
    xlinkHref: "#MYTaksEmptyState_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#MYTaksEmptyState_svg__b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.01 94.518)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.477,
    cy: 11.394,
    fill: "#4AA147",
    rx: 10.952,
    ry: 10.916
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M9.72 15.444a1.066 1.066 0 001.508 0l5.33-5.33a1.066 1.066 0 00-1.507-1.507l-4.576 4.576-2.445-2.444a1.066 1.066 0 00-1.507 1.507l3.198 3.198z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 57.563,
    height: 4.975,
    x: 19.188,
    y: 49.746,
    fill: "#D2DDEC",
    rx: 2.487
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57.563,
    height: 4.975,
    x: 19.188,
    y: 61.117,
    fill: "#D2DDEC",
    rx: 2.487
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57.563,
    height: 4.975,
    x: 19.188,
    y: 73.198,
    fill: "#D2DDEC",
    rx: 2.487
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.584,
    height: 4.975,
    x: 19.188,
    y: 98.071,
    fill: "#D2DDEC",
    rx: 2.487
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.635,
    height: 4.975,
    x: 19.188,
    y: 108.02,
    fill: "#D2DDEC",
    rx: 2.487
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D2DDEC",
    strokeWidth: 3,
    d: "M29.848 14.213h36.954v17.14a5 5 0 01-6.636 4.726L49.96 32.546a4.994 4.994 0 00-3.27 0l-10.207 3.533a5 5 0 01-6.635-4.725v-17.14h0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.721,
    height: 17.766,
    x: 20.609,
    fill: "#6E6EDB",
    fillRule: "nonzero",
    rx: 6
  })))));
}
export default SvgMyTaksEmptyState;